import type { QueryClient } from "@tanstack/react-query";
import { NotificationsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

import { NOTIFICATIONS_SCROLL_PAGE_SIZE } from "@/lib/services/notificationsService";

/** Server prefetch for dashboard notifications (all portals). */
export async function prefetchNotificationsGet(
  queryClient: QueryClient,
  userId: number,
  accessToken: string,
  page: number = 1,
  pageSize: number = NOTIFICATIONS_SCROLL_PAGE_SIZE,
) {
  const service = createAuthenticatedApi(NotificationsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.Notifications,
      "scroll",
      userId,
      page,
      pageSize,
      undefined,
      { readStatus: "", notificationType: "" },
    ],
    queryFn: () =>
      service.apiNotificationsUserIdGet({
        userId,
        page,
        pageSize,
      }),
    staleTime: 30 * 1000,
  });

  return queryClient;
}
